const DOCUMENT_TYPE = {
  CPF: '92114031039',
  RNE: 'V565371-S',
  PASSPORT: 'CS265436',
};

const CPF_ERRORS = ['23122543010', '76332311061'];

const EMAIL = 'test@email.com';
const OTHER_EMAIL_SMILES = 'smilesmember@yahoo.com';
const MEMBER_NUMBER = '730847633';
const BIRTHDATE_YYYY_MM_DD = '1999-08-19';
const BIRTHDATE_DD_MM_YYYY = '19/08/1999';
const PHONE_DDI = '55';
const PHONE_DDD = '31';
const PHONE_NUMBER = '997815503';
const SMS_NUMBER = `${PHONE_DDI}${PHONE_DDD}${PHONE_NUMBER}`;
const TOKEN_NUMBER = '101019';
const TOKEN_EMAIL = '698dc19d489c4e4db73e28a713eab07b';
const PASSWORD = '5439';
const COUNTRY = 'Brasil';
const ZIP_CODE = '30350199';
const NAME = 'Nome Sobrenome';
const TICKET_ID = '5f8772ec293b9e10dc8fb146';
const ATTACHMENTS = [
  {
    url: 'http://www.smiles.com.br',
    comments: 'comments',
  },
];

const SMILES_TOKEN =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudFR5cGUiOiJDUEYiLCJkb2N1bWVudE51bWJlciI6IjkyMTE0MDMxMDM5IiwiaWF0IjoxNjA2MjM2MjYzLCJleHAiOjE2MDYyNTA2NjN9.Q1vHO_OpWJaD8OSyBqITA1aOG8efUjbQsVRd7uedrEsso';

const ELETRONIC_ADDRESS_LIST = [
  {
    preferential: true,
    type: 'PERSONAL',
    address: EMAIL,
  },
];

const DOCUMENT_LIST = [
  {
    preferential: true,
    type: 'CPF',
    number: DOCUMENT_TYPE.CPF,
  },
];

const ADDRESS = {
  streetName: 'Rua do teste',
  streetNumber: '12A',
  complement: 'Próximo ao mercado',
  zipCode: '07123287',
  city: 'Guarulhos',
  state: 'SP',
  country: 'Brazil',
};

const ADDRESS_LIST = [
  {
    preferential: true,
    type: 'HOME',
    ...ADDRESS,
  },
];

const ADDRESS_LIST_UPDATE = [
  {
    preferential: true,
    ...ADDRESS,
  },
];

const PHONE_LIST = [
  {
    type: 'CELLULAR',
    internationalCode: '55',
    areaCode: '11',
    number: '24859874',
  },
];

const ACCEPT_TERMS = {
  accepted: true,
  termsOpened: false,
};

const MEMBER_CREATE = {
  name: NAME,
  password: PASSWORD,
  passwordConfirmation: PASSWORD,
  allowMail: true,
  allowSMS: true,
  allowPromoEmail: true,
  birthDate: BIRTHDATE_YYYY_MM_DD,
  phoneList: PHONE_LIST,
  documentList: DOCUMENT_LIST,
  addressList: ADDRESS_LIST,
  electronicAddressList: ELETRONIC_ADDRESS_LIST,
  acceptTerms: ACCEPT_TERMS,
  deviceFingerprint: '',
};

const MEMBER_UPDATE = {
  electronicAddressList: ELETRONIC_ADDRESS_LIST,
  addressList: ADDRESS_LIST_UPDATE,
  acceptTerms: ACCEPT_TERMS,
  contactType: 'EMAIL',
};

export default {
  DOCUMENT_TYPE,
  EMAIL,
  MEMBER_NUMBER,
  NAME,
  BIRTHDATE_YYYY_MM_DD,
  BIRTHDATE_DD_MM_YYYY,
  PHONE_DDI,
  PHONE_DDD,
  PHONE_NUMBER,
  SMS_NUMBER,
  TOKEN_NUMBER,
  TOKEN_EMAIL,
  PASSWORD,
  COUNTRY,
  ZIP_CODE,
  CPF_ERRORS,
  TICKET_ID,
  ATTACHMENTS,
  OTHER_EMAIL_SMILES,
  SMILES_TOKEN,
  ELETRONIC_ADDRESS_LIST,
  DOCUMENT_LIST,
  ADDRESS,
  ADDRESS_LIST,
  PHONE_LIST,
  ACCEPT_TERMS,
  MEMBER_CREATE,
  MEMBER_UPDATE,
};
